
const removeObjectIds = (schedule) => {
    let fixedSchedule = [];
    for (let [rdtId, resource] of Object.entries(schedule)) {
        let fixedResource = resource;
        if (resource.dayTypes) {
            let fixedDayTypes = [];
            for (let [rdtId, dayType] of Object.entries(resource.dayTypes)) {
                let fixedDayType = dayType;
                if (dayType.tour) {
                    const { tour } = dayType;
                    let fixedTour = tour;
                    if (tour.assignments) {
                        let fixedAssignments = [];
                        for (let [rdtId, assignment] of Object.entries(tour.assignments)) {
                            fixedAssignments.push(assignment);
                        }
                        fixedTour.assignments = fixedAssignments;
                    }
                    fixedDayType.tour = fixedTour;
                    fixedDayTypes.push(fixedDayType);
                } else {
                    fixedDayTypes.push(dayType);
                }
            }
            fixedResource.dayTypes = fixedDayTypes;
        }
        fixedSchedule.push(fixedResource);
    }
    return fixedSchedule;
}

export default removeObjectIds;
